import { useEffect, useState } from "react";
import {
  EVENEMENT_ENGAGE,
  choixMeta,
  enregistrerChoixMeta,
  metaDisponible,
  parcoursEngage,
} from "../lib/meta";
import { track } from "../lib/track";
import { useApp } from "../state/AppState";

// Un affichage compté par chargement de page, pas à chaque rendu.
let affichageCompte = false;

/**
 * Le bandeau de consentement Meta — T43, 04/10/2026.
 *
 * Il ne s'affiche que si un pixel est configuré **et** que l'exploitation l'a
 * autorisé, une fois le résultat affiché (07/10/2026 : au lancement, il couvrait
 * les boutons de la première tâche), et seulement tant que la personne n'a pas
 * choisi. Refuser est aussi
 * simple qu'accepter : deux boutons de même poids, et le refus est retenu.
 * Sans accord, aucun script ni cookie de Meta (voir `lib/meta.ts`).
 */
export function ConsentementMeta() {
  const { metaActif } = useApp();
  const [choisi, setChoisi] = useState(() => choixMeta() !== null);
  const [engage, setEngage] = useState(() => parcoursEngage());
  const visible = metaActif && metaDisponible() && !choisi && engage;

  // Il attend le premier geste du parcours, puis ne quitte plus l'onglet.
  useEffect(() => {
    if (engage) return;
    const ecouter = () => setEngage(true);
    window.addEventListener(EVENEMENT_ENGAGE, ecouter);
    return () => window.removeEventListener(EVENEMENT_ENGAGE, ecouter);
  }, [engage]);

  // Le bandeau flotte en bas : la page garde de quoi défiler sous lui, pour
  // que le dernier bouton d'un écran reste atteignable.
  useEffect(() => {
    document.body.classList.toggle("avec-consentement", visible);
    return () => document.body.classList.remove("avec-consentement");
  }, [visible]);

  // Affiché, accepté, refusé : trois compteurs anonymes dans /pilotage, pour
  // savoir quelle part du trafic Meta peut réellement voir (audit du 05/10).
  useEffect(() => {
    if (visible && !affichageCompte) {
      affichageCompte = true;
      track("meta_bandeau_vu");
    }
  }, [visible]);

  if (!visible) return null;

  const choisir = (choix: "accepte" | "refuse") => {
    enregistrerChoixMeta(choix);
    track(choix === "accepte" ? "meta_accepte" : "meta_refuse");
    setChoisi(true);
  };

  return (
    <div className="consentement" role="region" aria-label="Mesure publicitaire">
      <p>
        {/* Raccourci le 05/10/2026 à la demande du porteur : trois lignes pour
            dire ce que deux disent. Reste l'essentiel d'un accord éclairé —
            à qui, quoi, et ce qui ne part jamais. */}
        Mesurer nos publicités avec Meta ? Il ne reçoit que votre visite et votre achat, jamais
        vos réponses.{" "}
        <a href="#legal">En savoir plus</a>
      </p>
      <div className="consentement-choix">
        <button type="button" className="btn" onClick={() => choisir("refuse")}>
          Refuser
        </button>
        <button type="button" className="btn" onClick={() => choisir("accepte")}>
          Accepter
        </button>
      </div>
    </div>
  );
}
